module.exports = __webpack_public_path__ + "img/pifu.fd06a531.jpg";